import styled, { css } from 'styled-components';
import { colors } from '@prisjakt/ui-base';
import { switchProp } from 'styled-tools';

export const UserAvatar = styled.div`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; /* Some characters in Open Sans look weird here */
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${switchProp(
      'styling',
      { blue: colors.semiWhite },
      'transparent'
    )}
    no-repeat center/100%;
  border: 1px solid
    ${switchProp('styling', {
      light: css`
        ${p => p.theme.bg.primary};
      `,
      dark: css`
        ${p => p.theme.lines.tertiary};
      `,
      blue: 'none',
    })};
  color: ${switchProp('styling', {
    light: css`
      ${p => p.theme.bg.primary};
    `,
    dark: css`
      ${p => p.theme.lines.tertiary};
    `,
    blue: colors.lightBlue3,
  })};
  fill: currentColor;
  border-radius: 50%;
  user-select: none;
  text-transform: uppercase;
  overflow: hidden;
`;
